import { Renderer, Config, Scene, Camera } from "../base";
import { MaterialManager, webcadDefines } from "./index";
import * as TWEEN from "@tweenjs/tween.js";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";

/* WebCadRenderer
 * WebCAD用レンダラクラス.
 */
export class WebCadRenderer extends Renderer {
	private _dfd: any;
	private _startTime: number;
	private _timer: number;

	private _renderPass: RenderPass;
	public _ssaoPass: ShaderPass;

	private _dpr: number;
	public _fxaaPass: ShaderPass;
	private _lastTime: number;
	private _minGap: number;
	private _maxGap: number;
	private _matmgr: MaterialManager;

	public _copyPass: ShaderPass;

	constructor(container: any, params?: {}) {
		let sysEnv = Config.me.sysenv;
		let preserveBuffer = true; // chenged on 11/12/2019 for screenshot
		super(container, {
			antialias: !sysEnv.isPoorPlatform(),
			alpha: !sysEnv.isPoorPlatform(),
			preserveDrawingBuffer: preserveBuffer
		});

		this._dpr = 1.0;
		this.me.autoClear = false;
		if (window.devicePixelRatio !== undefined) { this._dpr = window.devicePixelRatio; }
		this._lastTime = new Date().getTime();
		this._minGap = sysEnv.isPoorPlatform() ? 40/*25fps*/ : 25/*40fps*/;
		this._maxGap = sysEnv.isPoorPlatform() ? 100/*10fps*/ : 50/*20fps*/;
	}

	public get deferred(): any { return this._dfd; }
	public set deferred(dfd: any) { this._dfd = dfd; }
	public set delay(msec: number) { this._timer = msec; this._startTime = Date.now(); }

	public get matmgr(): MaterialManager { return this._matmgr; }
	public set matmgr(mgr: MaterialManager) { this._matmgr = mgr; }

	public posprocess(timeStamp: number): void {
		super.posprocess(timeStamp);
		TWEEN.update();

		if (this.deferred != undefined) {
			if ((this.deferred.state != undefined) && (this.deferred.state() == 'pending')) {
				if (Date.now() - this._startTime > this._timer) this.deferred.resolve();
			}
			else if ((this.deferred.promise != undefined) && (this.deferred.promise.inspect().state == 'pending')) {
				if (Date.now() - this._startTime > this._timer) this.deferred.resolve();
			}
			else {
				this.deferred = undefined;
			}
		}
	}

	protected initPostEffect(): boolean {
		if (!super.initPostEffect()) return false;

		// Setup render pass
		if (this._renderPass == undefined) {
			this._renderPass = new RenderPass(this._rendering_scene.me, this._rendering_camera.me);
			(this._renderPass as any).renderToScreen = false;
		}

		this.canvasSizeChanged();
		return true;
	}

	public render(scene: Scene, camera: Camera): void {
		super.render(scene, camera);
	}

	public _render() {
		let effective = this.posteffect;
		let time = new Date().getTime();
		if (effective) {
			let gap = time - this._lastTime;
			if (gap < this._minGap) return;
		}

		this.me.clear();
		if (this.matmgr) this.matmgr.adjustForRendering(this);

		// Apply AA & AO effect.
		if (effective) {
			if (this._renderPass != undefined) {
				this._renderPass.camera = this._rendering_camera.me;
			}
		}
		// Default no effects.
		else {
			this.me.render(this._rendering_scene.me, this._rendering_camera.me);
		}
		this._lastTime = time;
	}
}
